/* @flow */

import { white } from '@braindate/ui/lib/token/palette';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    display: 'block',

    width: 12,
    height: 12,

    backgroundColor: ({ theme }: ThemeFunction) => theme.accentColor,
    border: ['solid', 2, white],
    borderRadius: '50%',
  },
  'root-large': {
    width: 14,
    height: 14,

    borderWidth: 1,
  },
  'root-darkBg': {
    borderColor: ({ theme }: ThemeFunction) => theme.colorBase,
  },
};
